import { ChangeEvent, useEffect, useRef } from 'react';

interface Props {
  id?: string;
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  onChange?: (checked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
}

export default function Checkbox({
  id,
  name,
  checked,
  disabled,
  indeterminate,
  onChange,
}: Props) {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !checked && indeterminate;
    }
  }, [ref, indeterminate, checked]);

  return (
    <input
      ref={ref}
      id={id}
      name={name}
      type="checkbox"
      checked={checked}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => onChange?.(e.target.checked, e)}
      disabled={disabled}
      className="h-4 w-4 appearance-auto rounded border-gray-300 bg-gray-100 text-indigo-600 focus:ring-2 focus:ring-indigo-500"
    />
  );
}
